import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveFlota } from '../../shared/components';

export type CreateFlotaPageProps = {};

const CreateFlotaPage: React.FC<CreateFlotaPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_flota);

  return <SaveFlota titlePage="Crear flota" />;
};

export default CreateFlotaPage;
